export const getSearchParams = (key: string, search: string) => {
  const params = new URLSearchParams(decodeURIComponent(search)).get(key);
  return params || "";
};
